import React, { FC } from 'react'

import { WarningModal } from 'components/WarningModal'

type WarningProps = {
  cancelAction: (() => void) | undefined
  updateParentState: () => void
}

export const AnnotationDeletionWarningModal: FC<WarningProps> = ({
  cancelAction,
  updateParentState,
}) => {
  const buttonProps = [
    { text: 'cancel', action: cancelAction },
    { text: 'confirm' },
  ]

  const warningText = `You are about to delete an annotation that is currently used by at least one
  document derived from this template. If you proceed, it will not be possible to edit any of those
  documents. Do you want to continue?`

  return (
    <WarningModal
      warningText={warningText}
      modalButtonProps={buttonProps}
      onSelection={updateParentState}
    />
  )
}
